import React from 'react';
import PropTypes from 'prop-types';
import arrowRight from '../../images/arrow-right.svg';

const SampleNextArrow = (props) => {
  const { className, style, onClick } = props;
  return (
    <button
      className={className}
      style={{
        ...style,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'black',
        borderRadius: '50%',
        height: '48px',
        width: '48px',
        boxShadow: '0px 6.33962px 8.15094px rgba(0, 0, 0, 0.0752295)',
        cursor: 'pointer',
        border: 0,
      }}
      type="button"
      onClick={onClick}>
      <img
        src={arrowRight}
        style={{
          pointerEvents: 'none',
        }}
        alt="arrow-right"
      />
    </button>
  );
};

SampleNextArrow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};

export default SampleNextArrow;
